module.exports = __webpack_public_path__ + "static/test-house-e2a306ba2f84b5f39ea1f03f517b91c0.jpg";